// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mc-1";
export var messageSideRight = "_mc-2";
export var orderLookupBubbleContainer = "_mc-0";
export var submitButton = "_mc-3";